import React from 'react';
import './Chapters.scss';
import PullQuote from '../PullQuote/PullQuote';
function Chapter6() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__paragraph">
          “And that color change is visible computationally from videos,” Dr. Demir says.
        </p>
        <p className="chapter__paragraph">
          This is called Photoplethysmography (PPG) signal. FakeCatcher converts those PPG signals
          with their temporal, spatial, and spectral properties into PPG maps and then builds a
          deep-learning approach to classify them as fake and real. For now, bad actors cannot use
          this technology to create more convincing deepfakes because the PPG map extraction cannot
          be replicated. The construction of PPG maps is not differentiable, so it cannot be plugged
          into a GAN (generative adversarial network, a machine-learning model) for making better
          deepfakes.
        </p>
        <p className="chapter__paragraph">
          Intel researchers are working on detection technology that considers multiple watermarks,
          making it even more effective. “Instead of just relying on one type of authenticity
          signal, we are trying to make many different detectors based on different, complementary
          signals,” Dr. Demir says. One of them looks at the skin, another looks at the eyes, and
          each detection method might tell you with a different percentage of confidence that the
          video is fake.
        </p>
        <p className="chapter__paragraph">
          Moreover, these watermarks can be used for{' '}
          <a
            href="https://ieeexplore.ieee.org/document/9304909"
            target="_blank"
            rel="sponsored"
            className="link"
          >
            source detection
          </a>
          , that is, understanding which generator created each deepfake video. Once its generator
          is known, it is much easier to detect and track the source of a deepfake,” Dr. Demir says.
          The team is also expanding its research to discover multi-modal signals which may contain
          even more complex clues about us as humans.
        </p>
      </section>
      <section className="chapter">
        <p className="chapter__title">The First Live Detection Technology</p>
        <p className="chapter__paragraph">
          The new frontier Intel is developing involves cutting-edge technology in which detection
          can actually happen live. The video of the Ukrainian president was deemed a fake when
          viewers noticed that his accent and voice were off, among other signs. But the video was
          nonetheless widely distributed. If detection can occur live and in real-time, it would
          prevent damaging videos from spreading in the first place. Intel is leading the industry
          in this live-detection technology. Dr. Demir says that Intel has “the world's first
          real-time deepfake detection platform and it can run up to 72 concurrent detection streams
          on 3rd Gen Intel® Xeon® Scalable processors.”
        </p>
        <p className="chapter__paragraph">
          The efforts of Intel’s Trusted Media are in service of avoiding a potentially catastrophic
          situation through advanced detection technology that is customer-ready. Dr. Demir says
          that the team is actively demonstrating the platform for real-time detection of deepfakes
          found in real-world settings, so customers can deploy the platform into their workflows.
          And with Intel Labs’ diligent research and innovations like live deepfake detection, the
          technology to combat this threat is rapidly advancing.
        </p>
        <p className="chapter__paragraph">
          * Other names and brands can be claimed as the property of others.
        </p>
      </section>
      <section>
        <PullQuote
          quote={'The threat is very real, and the threat is coming with silent steps.'}
          author={'Dr. Ilke Demir, '}
          source={'Intel Labs'}
        />
      </section>
    </>
  );
}

export default Chapter6;
